export default "__VITE_ASSET__BLOnS6xW__"